export default "/fonts/vendor/balm-ui/material-icons.woff?1dd1bb366e173805f48f9ca20acddf46";